import React from 'react';
import { formatLondon } from '../../utils/dateFormatting';

// The scheduler's next on/off transitions as chips.
const PlannedActions = ({ actions }) => {
    if (!actions || actions.length === 0) return null;
    return (
        <div className="mb-3">
            <div className="text-[11px] font-semibold text-gray-400 uppercase tracking-wider mb-1">Planned actions</div>
            <div className="flex flex-wrap gap-2">
                {actions.map((a, i) => (
                    <span key={i} className={`text-[11px] px-2 py-1 rounded-md ${a.action === 'on' ? 'bg-indigo-50 text-indigo-700' : 'bg-slate-100 text-slate-600'}`}>
                        {a.action === 'on' ? '▲ ON' : '▼ OFF'}{' '}
                        {formatLondon(a.time, 'weekdayTime')}
                        {a.action === 'on' && a.temp != null ? ` → ${a.temp}°C` : ''}
                        {a.label ? ` · ${a.label}` : ''}
                    </span>
                ))}
            </div>
        </div>
    );
};

export default PlannedActions;
